<template>
  <div class="container mt-lg-5 mb-5">
    <div class="d-flex flex-row align-items-center gap-2 mb-3">
      <router-link to="/personas/permisos" class="btn d-flex align-items-center justify-content-center p-0 pt-1 tooltip-container">
        <svg width="30" height="30" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M6 12H18M6 12L11 7M6 12L11 17" class="stroke-principal" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        <span class="tooltip-text">{{ $t('volver') }}</span>
      </router-link>
      <h2 class="m-0">{{ $t('crearPermiso') || 'Nuevo Permiso' }}</h2>
    </div>

    <div>
      <form @submit.prevent="saveChanges" class="d-flex flex-column gap-3">

        <div class="fs-7 w-100">
          <strong>{{ $t('nombrePermiso') || 'Nombre del Permiso' }}:</strong> 
          <input 
            type="text" 
            v-model="nuevoPermiso.permisoNombre" 
            class="form-control sombra-sm mt-1" 
            placeholder="Ej: Usuarios:Exportar:Excel"
            required
          />
        </div>

        <div class="row">
          <div class="col-md-6 fs-7 mb-2">
            <strong>{{ $t('categoria') }}:</strong>
            <input 
              type="text" 
              v-model="nuevoPermiso.categoria" 
              class="form-control sombra-sm mt-1" 
              placeholder="Ej: Reportes"
            />
          </div>
          <div class="col-md-6 fs-7 mb-2">
            <strong>{{ $t('subCategoria') }}:</strong>
            <input 
              type="text" 
              v-model="nuevoPermiso.subCategoria" 
              class="form-control sombra-sm mt-1" 
              placeholder="Ej: Personas"
            />
          </div>
        </div>

        <div class="fs-7 w-100">
          <strong>{{ $t('descripcion') }}:</strong> 
          <textarea 
            id="descripcion" 
            v-model="nuevoPermiso.descripcion" 
            class="form-control sombra mt-1" 
            style="height: 120px; resize: none;" 
            maxlength="1000"
            placeholder="Escriba aquí los detalles y alcances del nuevo permiso..."
          ></textarea>
          <div class="mt-2 text-end">
            <span class="text-muted fs-8">{{ nuevoPermiso.descripcion?.length ?? 0 }}/1000 {{ $t('caracteres') }}</span>
          </div>
        </div>

        <div class="d-flex flex-row gap-2 align-items-center">
          <button class="btn btn-success mt-3 sombra-sm" type="submit" :disabled="loading">
            {{ $t('guardar') }}
          </button>
          <button class="btn btn-secondary mt-3 sombra-sm" type="button" @click="cancelar" :disabled="loading">
            {{ $t('cancelar') }}
          </button>
          
          <div v-if="loading" class="loading-spinner d-flex flex-row align-items-center justify-content-center ms-3 mt-3">
            <img src="@/assets/LOADING.gif" style="width: 40px;" alt="Cargando..." />
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue';
import { useRouter } from "vue-router";
import { useI18n } from 'vue-i18n';
import api from '@/services/api';

export default {
  name: 'CrearPermiso',
  setup() {
    const { t } = useI18n();
    const router = useRouter();
    const loading = ref(false);

    // Estructura limpia que requiere tu CreatePermisoDto en C#
    const nuevoPermiso = ref({
      permisoNombre: '',
      descripcion: '',
      categoria: '',
      subCategoria: ''
    });

    const saveChanges = async () => {
      try {
        loading.value = true;
        
        // Convertimos campos vacíos en null
        convertEmptyToNull(nuevoPermiso.value);

        const data = {
          permisoNombre: nuevoPermiso.value.permisoNombre,
          descripcion: nuevoPermiso.value.descripcion,
          categoria: nuevoPermiso.value.categoria,
          subCategoria: nuevoPermiso.value.subCategoria
        };

        // Invocamos el endpoint POST de tu backend
        await api.post(`api/permisos`, data);
        
        loading.value = false;
        // Redirigimos de vuelta al listado de permisos
        await router.push('/personas/permisos');
      } catch (error) {
        console.error('Error al guardar el nuevo permiso:', error);
        loading.value = false;
        
        // Manejo amigable si el backend devuelve un 490 Conflict (Mismo nombre)
        if (error.response && error.response.status === 409) {
          alert(error.response.data || 'Ya existe un permiso con ese nombre.');
        } else {
          alert('Hubo un problema al guardar los datos del permiso.');
        }
      }
    };

    const convertEmptyToNull = (obj) => {
      Object.keys(obj).forEach((key) => {
        if (obj[key] === "") {
          obj[key] = null;
        }
      });
    };

    const cancelar = async () => {
      await router.push('/personas/permisos');
    };

    onMounted(() => {
      const lastUpdate = localStorage.getItem("lastUpdate_crearPermiso");
      const today = new Date().toISOString().split("T")[0];

      if (lastUpdate !== today) {
        localStorage.setItem("lastUpdate_crearPermiso", today);
        window.location.reload();
      }
    });

    return {
      t,
      nuevoPermiso,
      loading,
      saveChanges,
      cancelar
    };
  },
};
</script>

<style scoped>
/* Estilos opcionales para la vista */
</style>